module.exports = __webpack_public_path__ + "img/sick-icon.8db63f99.svg";